import React from "react";
import { Flex, Spin } from "antd";
import DoctorListItem from "./DoctorListItem";

function ConversedDoctorsList({
  doctors,
  isLoading,
  unreadCounts,
  onSelectDoctor,
  onOpenAllDoctors,
  onSearchChange,
}) {
  return (
    <div className="w-full max-w-sm mx-auto bg-white shadow-lg rounded-lg">
      <div className="flex items-center p-4 border-b">
        <button className="text-gray-500 cursor-pointer" onClick={onOpenAllDoctors}>
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M4 6h16M4 12h16m-7 6h7"
            ></path>
          </svg>
        </button>
        <input
          type="text"
          placeholder="Search"
          className="ml-4 flex-1 px-4 py-2 rounded-full bg-gray-100 outline-none"
          onChange={onSearchChange}
        />
      </div>

      <div>
        {isLoading && doctors.length === 0 ? (
          <div className="h-screen flex items-center justify-center">
            <Flex align="center" gap="middle">
              <Spin size="large" tip="Loading" />
            </Flex>
          </div>
        ) : !isLoading && doctors.length === 0 ? (
          <div className="h-screen flex flex-col gap-1 justify-center items-center">
            <p className="text-lg font-light">No conversations.</p>
          </div>
        ) : (
          doctors.map((doctor) => (
            <DoctorListItem
              key={doctor.userId}
              doctor={doctor}
              unreadCount={unreadCounts[doctor.userId]}
              onClick={() => onSelectDoctor(doctor)}
            />
          ))
        )}
      </div>
    </div>
  );
}

export default ConversedDoctorsList;